module.exports = __webpack_public_path__ + "img/ic_team_instagram_white.f9273b47.svg";